import axiosClient from "./axiosClient";

export const getOrders = () => axiosClient.get("/orders").then((res) => res.data);

export const createOrder = (orderData) =>
    axiosClient.post("/orders", orderData).then((res) => res.data);

export const updateOrderStatus = (id, status) =>
    axiosClient.put(`/orders/${id}`, { status }).then((res) => res.data);

export const deleteOrder = (id) => axiosClient.delete(`/orders/${id}`).then((res) => res.data);
